import script from "./SetupLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./SetupLinks.vue?vue&type=script&setup=true&lang=js"

import "./SetupLinks.vue?vue&type=style&index=0&id=43f2355a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43f2355a"]])

export default __exports__